<template>
  <div>
    <el-form-item>
      <template #label>{{ codeEnum.code }}</template>
      <el-row :gutter="gutter">
        <el-col :span="span1" class="col_positon">
          <el-input
            v-model="localInputVal"
            class="left_input"
            :disabled="showList || localDisabled"
            :class="[showList ? 'multiple' : '']"
            @input="handleLocalInputVal"
            @blur="handleBlur"
          />
          <div
            v-if="!localDisabled"
            class="more_box flex_center flex_center_align"
            @click="selectDep"
          >
            <svg-icon icon-class="select"></svg-icon>
          </div>
        </el-col>
        <el-col :span="span2">
          <el-input
            v-model="localInputName"
            class="right_input"
            :class="[showList ? 'multiple' : '']"
            disabled
          />
          <el-popover v-show="showList" placement="bottom" trigger="click">
            <el-table :data="list" border stripe>
              <el-table-column
                width="100"
                header-align="center"
                align="center"
                property="itmdtlcd"
                label="商品明細CD"
              ></el-table-column>
              <el-table-column
                width="180"
                property="itmdtlnm"
                header-align="center"
                align="center"
                label="商品明細名"
              ></el-table-column>
            </el-table>
            <div
              slot="reference"
              class="more_box flex_center flex_center_align more_change_box"
            >
              <div class="inner_box flex_center flex_center_align">
                <svg-icon :icon-class="'sel'"></svg-icon>
              </div>
            </div>
          </el-popover>
        </el-col>
      </el-row>
    </el-form-item>
    <MitmdtlpDialogNew
      ref="dialog"
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      :code-field="codeField"
      :name-field="nameField"
      :goodslists="goodslists"
      :multi-select="multiSelect"
      @get-selection="getSelection"
    />
  </div>
</template>

<script>
  import mixComponent from '@/utils/mixComponent'
  import { getmitmdtlp } from '@/api/mitmdtlp'
  export default {
    // 商品明細
    name: 'Mitmdtlp',
    mixins: [mixComponent],
    props: {
      goodslists: {
        type: Array,
        default: () => [],
      },
      codeEnum: {
        type: Object,
        default: () => {
          return {
            code: '商品明細',
            value: '商品明細CD',
            text: '商品明細選択',
            table: '商品明細マスタ',
          }
        },
      },
    },
    // watch: {
    //   goodslists: function (newValue, oldValue) {
    //     if (!_.isEqual(newValue, oldValue)) {
    //       this.reset()
    //     }
    //   },
    // },
    created() {
      this.codeField = 'itmdtlcd'
      this.nameField = 'itmdtlnm'
    },
    methods: {
      initParams() {
        let dialog = this.$refs['dialog']
        let itmcdList = this.$baseLodash.map(this.goodslists, 'itmcd')
        let queryForm = dialog.queryForm
        queryForm.itmdtlcd = null
        queryForm.itmdtlnmk = null
        queryForm.itmcdList = itmcdList
      },
      async getOne(val) {
        return getmitmdtlp(val)
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '@/vab/styles/component.scss';
</style>
